import { render, staticRenderFns } from "./personaldetail.vue?vue&type=template&id=8766c104&scoped=true&"
import script from "./personaldetail.vue?vue&type=script&lang=js&"
export * from "./personaldetail.vue?vue&type=script&lang=js&"
import style1 from "./personaldetail.vue?vue&type=style&index=1&id=8766c104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8766c104",
  null
  
)

export default component.exports